// One error boundary per routed screen: a render error in one module is contained, logged into the
// diagnostics bundle, and shown with a way back — the rest of AVRASTRO keeps working (spec §73).
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from './runtime.tsx';

interface Props { module: string; labels: { title: string; body: string; retry: string; home: string }; children?: ReactNode }
interface State { error: Error | null }

export class ScreenBoundary extends Component<Props, State> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { reportError(Object.assign(error, { stack: `${error.stack ?? ''}\n${info.componentStack ?? ''}` }), this.props.module); }
  override render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const L = this.props.labels;
    return (
      <div className="card card-pad" role="alert" data-testid="screen-error" style={{ maxWidth: 640, margin: '40px auto', textAlign: 'center' }}>
        <h2 style={{ margin: '0 0 8px' }}>{L.title}</h2>
        <p className="muted">{L.body}</p>
        <pre className="code" style={{ textAlign: 'start' }}>{error.message}</pre>
        <div className="row" style={{ justifyContent: 'center', marginTop: 12 }}>
          <button className="btn" onClick={() => this.setState({ error: null })}>{L.retry}</button>
          <button className="btn btn-primary" onClick={() => { this.setState({ error: null }); location.hash = '#/now'; }}>{L.home}</button>
        </div>
      </div>
    );
  }
}
